export default "__VITE_ASSET__0f83ca05__"